import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.87 12.218c-.549 0-.985-.423-.985-.954V6.222c0-.531.436-.953.985-.953.55 0 .986.422.986.953v5.042c0 .518-.437.954-.986.954M9.8 13.24c.466 0 .845.365.845.817a.83.83 0 0 1-.845.817.83.83 0 0 1-.845-.817c0-.452.378-.818.845-.818",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "10",
  r: "9",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }